<script setup lang="ts">
import { onMounted, watch } from 'vue';
import { RouterView } from 'vue-router';
import { useWalletSession } from '@src/shared/lib/composables/useWalletSession';
import { useAppConfigStore } from '@src/shared/stores/app-config';
import ModalHost from '@src/shared/ui/ModalHost.vue';
import AppFooter from '@src/widgets/app-shell/AppFooter.vue';
import AppHeader from '@src/widgets/app-shell/AppHeader.vue';
import AppMobileNav from '@src/widgets/app-shell/AppMobileNav.vue';

const appConfig = useAppConfigStore();
const { address, isConnected } = useWalletSession();

onMounted(async () => {
	await appConfig.init();
});

watch([isConnected, address], ([connected, walletAddress]) => {
	appConfig.setWalletAddress(connected ? walletAddress : null);
});
</script>

<template>
	<div class="flex min-h-dvh flex-col main-bg">
		<app-header />
		<main class="flex-1 max-w-7xl px-6 sm:px-4 mx-auto w-full mb-24 sm:mb-20">
			<RouterView />
		</main>
		<app-footer />
		<ModalHost />
		<app-mobile-nav />
	</div>
</template>

<style>
html,
body {
	margin: 0;
	padding: 0;
	background: #000000;
	min-height: 100%;
}

.main-bg {
	background-color: #0c0c0e;
}

@media (max-width: 560px) {
	.main-bg {
		background-color: #0d0d0d;
		background-image: url('/src/shared/assets/icons/mobile-bg.png');
		background-size: 100%;
		background-repeat: no-repeat;
	}
	.main-bg::before {
		opacity: 0.2 !important;
	}
}

.main-bg::before,
.panel-bg::before {
	content: '';
	position: fixed;
	inset: 0;
	background: url('/src/shared/assets/icons/noise-bg2.png');
	pointer-events: none;
	background-size: contain;
	opacity: 0.1;
}

.panel-bg {
	background-color: #0d0d0d;
	background-image: url('/src/shared/assets/icons/panel-bg.png');
	background-size: 100%;
	background-repeat: no-repeat;
}
</style>
